import React, {Component} from 'react';
import searchProductsCount from '../api/searchProductsCount';
import isNumber from 'lodash/isNumber';

export default class PaginatedProductCount extends Component {
	constructor() {
		super();

		this.state = {
			count: null,
		};
	}

	componentDidMount = () => {
		searchProductsCount(this.props.query)
			.then((response) => {
				this.setState({
					count: isNumber(response.count) ? response.count : 0,
				});
			})
			.catch(error => {
				console.log(error);
			});
	}

	render() {
		const {count} = this.state;

		if (count === null) {
			return (
				<p className="sans--small color--gray-text">
					<br/>
				</p>
			);
		}

		return (
			<p className="sans--small color--gray-text">
				Showing {count} Results
			</p>
		);
	}
}